import { Outlet } from "react-router-dom";
import { Truck, RefreshCw, Wallet, BadgePercent, MessageCircle } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import { waLink } from "@/lib/content";

const MSGS = [
  [Truck, "Free Shipping Across India"],
  [RefreshCw, "Easy Size Exchange"],
  [Wallet, "100% Secure Prepaid Orders"],
  [BadgePercent, "Extra 10% OFF on Prepaid Orders"],
];

export const AnnouncementBar = () => (
  <div data-testid="announcement-bar" className="overflow-hidden bg-[#701A24] text-[#F7E9DC]">
    <div className="marquee flex w-max gap-14 py-2 text-[11px] font-medium tracking-[0.14em] uppercase sm:text-xs">
      {[...MSGS, ...MSGS, ...MSGS, ...MSGS].map(([Icon, t], i) => (
        <span key={i} className="flex items-center gap-2 whitespace-nowrap">
          <Icon className="h-3.5 w-3.5 text-[#D99B8E]" /> {t}
        </span>
      ))}
    </div>
  </div>
);

export const WhatsAppFab = () => (
  <a
    data-testid="whatsapp-fab"
    href={waLink("Hi Kurtaani, I have a question about a product / size.")}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat with Kurtaani on WhatsApp"
    className="group fixed bottom-24 right-4 z-40 flex items-center gap-2 rounded-full bg-[#25D366] p-3.5 text-white shadow-lg transition-transform duration-200 hover:scale-105 md:bottom-6 md:right-6"
  >
    <MessageCircle className="h-6 w-6" />
    <span className="hidden max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-all duration-300 group-hover:max-w-[180px] md:inline">Size help? Chat</span>
  </a>
);

export default function Layout() {
  return (
    <div className="App overflow-x-clip bg-[#FAF7F2]">
      <AnnouncementBar />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <WhatsAppFab />
    </div>
  );
}
